import React from 'react';
import { add as addToCartService } from '../Services/Cart.service';
import withReactiveStyleBuyButton from './withReactiveStyleBuyButton';
import { load as loadCart, loadError } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import { useDispatch } from 'react-redux';

const BuyButton = ({
    label,
    articleNumber,
    quantityFieldId,
    includeAccessoryItems,
    href,
    cssClass,
    onClick,
}) => {
    function handleOnClick(e) {
        e.preventDefault();
        onClick({ articleNumber, quantityFieldId, includeAccessoryItems });
    }
    
    const onClickFn = articleNumber
        ? handleOnClick
        : null;
    
    return (
        <a className={cssClass}
           onClick={onClickFn}
           href={href || '#'}
           rel="nofollow">
            {label}
        </a>
    );
};

const StyledButton = (props) => {
    const dispatch = useDispatch();
    
    async function onClick({ articleNumber, quantityFieldId, includeAccessoryItems }) {
        try {
            let accessoryItems = [];
            
            if (includeAccessoryItems === "true") {
                const selectedAccessoryItems = document.getElementsByClassName("product-detail__accessory-item product-detail__accessory-item--active");
           
                accessoryItems = Array.from(selectedAccessoryItems, (el => ({
                    itemId: el.dataset.itemId,
                    isDefault: el.dataset.itemDefault,
                    placement: el.dataset.itemPlacement
                })));
            }

            const quantity = quantityFieldId
                ? Number(document.getElementById(quantityFieldId).value)
                : 1;
            
            await addToCartService({
                articleNumber,
                quantity,
                accessoryItems,
            });
            dispatch(loadCart());
            
            return true;
        } catch (ex) {
            dispatch(catchError(ex, (error) => loadError(error)));
            return false;
        }
    }
    
    const Button = withReactiveStyleBuyButton(BuyButton, onClick, 'buy-button');

    return <Button {...props} />;
};

export default StyledButton;
